import React from 'react'
import BIFMA from './assets/bifma.png'
import USA from './assets/usa.png'
import WARRANTY from './assets/warranty.png'
import './LandingPage.css'

const s3 = process.env.REACT_APP_S3

const LandingPage = () => {
  return (
    <div className="onepointe">
    <div className="main-container col1-layout">
            <div className="main">
                                <div className="col-main">
<div className="design design10">
<div className="col-1-1">
<div className="box image-box"><img alt="" src={s3 + "/images/700px/standard/PDHCH-RG-T0-A0-RC.png"}/>
<div className="kc-product-info">
<h1>LABORATORY SEATING</h1>
<p>Our laboratory chairs feature the latest advancements in laboratory ergonomics, such as contoured waterfall cushions and 6-way armrests, for improved posture and blood circulation.</p>
<p className="tags"><strong>Styles</strong> Chairs, Stools, &amp; Stools with Backs</p>
<a href="/laboratory-seating"><button className="main-button">Shop Now</button></a></div>
</div>
</div>
<div className="col-1-1" style={{minHeight: "215px"}}>
<div className="col-1-3 sticker-banner"><img src={BIFMA} style={{width: "calc(100% - 20px)", border: "10px solid white"}}/></div>
<div className="col-1-3 sticker-banner"><img src={USA} style={{width: "calc(100% - 20px)", border: "10px solid white", borderRight: "5px solid white"}}/></div>
<div className="col-1-3 sticker-banner"><img src={WARRANTY} style={{width: "calc(100% - 20px)", border: "10px solid white"}}/></div>
</div>
<div className="col-1-2">
<div className="box mesh"><img alt="" src={s3 + "/images/320px/standard/MOD-MDHCH-RG-C1-A0-RC.png"}/>
<h2>NEW<br/> Oxford Mesh Chair</h2>
<a href="https://chairs.onepointesolutions.com/product?id=MOD-MDHCH-RG#MOD-MDHCH-RG-C2-A2-RC"><button><strong>Shop Now</strong></button></a></div>
</div>
<div className="col-1-2">
<div className="box mesh"><img alt="" src={s3 + "/images/320px/standard/EXE-MDHCH-RG-H0-A1-RC.png"}/>
<h2>NEW<br/> Windrowe Mesh Chair</h2>
<a href="https://chairs.onepointesolutions.com/product?id=EXE-MDHCH-RG#EXE-MDHCH-RG-H0-A2-RC"><button><strong>Shop Now</strong></button></a></div>
</div>
<div className="col-1-1">
<div className="box banner">
<h2>Build Your Chair</h2>
<p>BUILD THE RIGHT CHAIR FOR YOUR ENVIRONMENT.</p>
<a href="/chair-guide"><button><strong>Build Now</strong></button></a></div>
</div>
<div className="col-1-4">
<div className="box"><img alt="" src={s3 + "/images/320px/standard/ESD-VMBCH-CR-T0-A0-CF-EG-ESDBLU.png"}/>
<h4>ESD &amp; Cleanroom</h4>
<a href="/controlled-environment-seating"><button>Shop Now</button></a></div>
</div>
<div className="col-1-4">
<div className="box"><img alt="" src={s3 + "/images/700px/standard/PDHCH-RG-T0-A0-RC.png"}/>
<h4>Industrial Seating</h4>
<a href="/industrial-seating"><button>Shop Now</button></a></div>
</div>
<div className="col-1-4">
<div className="box"><img alt="" src={s3 + "/images/320px/standard/FDHCH-RG-T0-A1-RC-F41.png"}/>
<h4>Office Seating</h4>
<a href="/office-seating"><button>Shop Now</button></a></div>
</div>
<div className="col-1-4">
<div className="box"><img alt="" src={s3 + "/images/320px/standard/VDHCH-RG-T0-A1-RC-8567.png"}/>
<h4>Medical Seating</h4>
<a href="/medical-seating"><button>Shop Now</button></a></div>
</div>
</div></div>                </div>
            </div>
    </div>
  )
}

export default LandingPage
